// Mock data for the barbershop/salon demo

export const branches = [
  {
    id: 'monterrey',
    name: 'Monterrey Centro',
    address: 'Av. Constitución 1500, Centro, Monterrey',
    phone: '+52 81 1234 5678',
    hours: 'Lun-Sáb: 9:00-20:00 | Dom: 10:00-16:00',
    parking: true,
    coordinates: { lat: 25.6866, lng: -100.3161 },
    mapPosition: { x: 30, y: 40 }
  },
  {
    id: 'san-pedro',
    name: 'San Pedro',
    address: 'Calzada del Valle 400, San Pedro Garza García',
    phone: '+52 81 2345 6789',
    hours: 'Lun-Sáb: 10:00-21:00 | Dom: 11:00-17:00',
    parking: true,
    coordinates: { lat: 25.6574, lng: -100.4019 },
    mapPosition: { x: 50, y: 55 }
  },
  {
    id: 'cumbres',
    name: 'Cumbres',
    address: 'Paseo de los Leones 2800, Cumbres, Monterrey',
    phone: '+52 81 3456 7890',
    hours: 'Lun-Sáb: 9:00-20:00 | Dom: Cerrado',
    parking: true,
    coordinates: { lat: 25.7252, lng: -100.3755 },
    mapPosition: { x: 70, y: 30 }
  }
];

export const services = [
  {
    id: 'corte-clasico',
    name: 'Corte Clásico',
    category: 'Cortes',
    price: 250,
    duration: 30,
    description: 'Corte tradicional con tijera y máquina, incluye lavado.',
    image: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=400',
    addOns: ['cejas', 'lavado-premium']
  },
  {
    id: 'fade',
    name: 'Fade Premium',
    category: 'Cortes',
    price: 350,
    duration: 45,
    description: 'Degradado perfecto con detalle en líneas y diseño.',
    image: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=400',
    addOns: ['cejas', 'diseno', 'lavado-premium'],
    popular: true
  },
  {
    id: 'corte-nino',
    name: 'Corte Niño',
    category: 'Cortes',
    price: 180,
    duration: 25,
    description: 'Corte para menores de 12 años.',
    image: 'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=400',
    addOns: ['lavado-premium']
  },
  {
    id: 'barba-completa',
    name: 'Barba Completa',
    category: 'Barba',
    price: 200,
    duration: 30,
    description: 'Perfilado, recorte y aceites esenciales.',
    image: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=400',
    addOns: ['toalla-caliente', 'aceite-premium']
  },
  {
    id: 'barba-diseno',
    name: 'Barba con Diseño',
    category: 'Barba',
    price: 280,
    duration: 40,
    description: 'Perfilado artístico con líneas y detalles personalizados.',
    image: 'https://images.unsplash.com/photo-1596728325488-58c87691e9af?w=400',
    addOns: ['toalla-caliente', 'aceite-premium'],
    popular: true
  },
  {
    id: 'tinte-cabello',
    name: 'Tinte Cabello',
    category: 'Color',
    price: 450,
    duration: 60,
    description: 'Coloración profesional con productos premium.',
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400',
    addOns: ['tratamiento-hidratante']
  },
  {
    id: 'mechas',
    name: 'Mechas / Highlights',
    category: 'Color',
    price: 650,
    duration: 90,
    description: 'Mechas naturales o de contraste.',
    image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400',
    addOns: ['tratamiento-hidratante', 'toner']
  },
  {
    id: 'facial-express',
    name: 'Facial Express',
    category: 'Facial',
    price: 180,
    duration: 20,
    description: 'Limpieza rápida con exfoliación y mascarilla.',
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400',
    addOns: ['masaje-facial']
  },
  {
    id: 'facial-completo',
    name: 'Facial Completo',
    category: 'Facial',
    price: 380,
    duration: 45,
    description: 'Tratamiento completo con vapor, extracción y mascarilla premium.',
    image: 'https://images.unsplash.com/photo-1552693673-1bf958298935?w=400',
    addOns: ['masaje-facial', 'serum-vitamina-c'],
    popular: true
  },
  {
    id: 'manicure',
    name: 'Manicure Caballero',
    category: 'Uñas',
    price: 150,
    duration: 25,
    description: 'Cuidado de uñas y cutícula con acabado natural.',
    image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?w=400',
    addOns: []
  },
  {
    id: 'paquete-novio',
    name: 'Paquete Novio',
    category: 'Paquetes',
    price: 850,
    duration: 120,
    description: 'Corte + Barba + Facial + Manicure. Ideal para el gran día.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    addOns: [],
    popular: true
  },
  {
    id: 'paquete-ejecutivo',
    name: 'Paquete Ejecutivo',
    category: 'Paquetes',
    price: 550,
    duration: 75,
    description: 'Corte Fade + Barba Completa + Facial Express.',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400',
    addOns: []
  }
];

export const addOns = [
  { id: 'cejas', name: 'Perfilado de Cejas', price: 50, duration: 10 },
  { id: 'diseno', name: 'Diseño / Líneas', price: 80, duration: 15 },
  { id: 'lavado-premium', name: 'Lavado Premium', price: 40, duration: 10 },
  { id: 'toalla-caliente', name: 'Toalla Caliente', price: 30, duration: 5 },
  { id: 'aceite-premium', name: 'Aceite de Barba Premium', price: 60, duration: 5 },
  { id: 'tratamiento-hidratante', name: 'Tratamiento Hidratante', price: 120, duration: 15 },
  { id: 'toner', name: 'Toner Matizador', price: 150, duration: 20 },
  { id: 'masaje-facial', name: 'Masaje Facial', price: 80, duration: 15 },
  { id: 'serum-vitamina-c', name: 'Serum Vitamina C', price: 100, duration: 5 }
];

export const specialists = [
  {
    id: 'carlos',
    name: 'Carlos Mendoza',
    role: 'Master Barber',
    image: 'https://images.pexels.com/photos/1453005/pexels-photo-1453005.jpeg?w=400',
    rating: 4.9,
    reviews: 287,
    specialties: ['Cortes', 'Fade', 'Diseños', 'Barba'],
    experience: '8 años',
    availability: ['monterrey', 'san-pedro'],
    bio: 'Especialista en fades y diseños artísticos. Ganador del concurso regional de barberos 2023.'
  },
  {
    id: 'sofia',
    name: 'Sofía Ramírez',
    role: 'Colorista Senior',
    image: 'https://images.pexels.com/photos/668196/pexels-photo-668196.jpeg?w=400',
    rating: 4.8,
    reviews: 195,
    specialties: ['Color', 'Mechas', 'Tratamientos'],
    experience: '6 años',
    availability: ['san-pedro'],
    bio: 'Experta en técnicas de coloración moderna. Certificada en Wella y L\'Oréal.'
  },
  {
    id: 'miguel',
    name: 'Miguel Torres',
    role: 'Barber & Grooming',
    image: 'https://images.pexels.com/photos/7697287/pexels-photo-7697287.jpeg?w=400',
    rating: 4.7,
    reviews: 156,
    specialties: ['Cortes', 'Corte Clásico', 'Barba', 'Facial'],
    experience: '5 años',
    availability: ['monterrey', 'cumbres'],
    bio: 'Especializado en el cuidado integral masculino. Técnicas tradicionales con toque moderno.'
  },
  {
    id: 'andrea',
    name: 'Andrea López',
    role: 'Esteticista',
    image: 'https://images.pexels.com/photos/4123900/pexels-photo-4123900.jpeg?w=400',
    rating: 4.9,
    reviews: 224,
    specialties: ['Facial', 'Uñas', 'Tratamientos'],
    experience: '7 años',
    availability: ['san-pedro', 'cumbres'],
    bio: 'Certificada en tratamientos faciales avanzados. Dermocosmetóloga.'
  },
  {
    id: 'david',
    name: 'David Garza',
    role: 'Junior Barber',
    image: 'https://images.pexels.com/photos/5490240/pexels-photo-5490240.jpeg?w=400',
    rating: 4.6,
    reviews: 89,
    specialties: ['Cortes', 'Fade Básico'],
    experience: '2 años',
    availability: ['monterrey', 'cumbres'],
    bio: 'Joven talento con pasión por los cortes modernos. Precios accesibles.'
  },
  {
    id: 'lucia',
    name: 'Lucía Fernández',
    role: 'Colorista & Stylist',
    image: 'https://images.pexels.com/photos/13098976/pexels-photo-13098976.jpeg?w=400',
    rating: 4.8,
    reviews: 178,
    specialties: ['Color', 'Corte Femenino', 'Styling'],
    experience: '9 años',
    availability: ['san-pedro'],
    bio: 'Artista del color con enfoque en looks naturales y sofisticados.'
  }
];

export const promos = [
  {
    id: 'horas-valle',
    name: 'Horas Valle',
    discount: 20,
    description: 'Descuento del 20% de Lunes a Jueves entre 12:00 y 16:00',
    conditions: 'Válido solo en servicios regulares. No acumulable.',
    validDays: ['lunes', 'martes', 'miércoles', 'jueves'],
    validHours: { start: 12, end: 16 },
    code: 'VALLE20',
    active: true
  },
  {
    id: '2x1-barba',
    name: '2x1 Barba con Corte',
    discount: 100,
    discountType: 'fixed',
    description: 'Tu barba GRATIS al agendar cualquier corte',
    conditions: 'Limitado a 10 espacios por día. Reserva anticipada requerida.',
    validServices: ['corte-clasico', 'fade', 'corte-nino'],
    freeService: 'barba-completa',
    code: 'BARBAGRATIS',
    active: true,
    limited: true,
    remaining: 4
  },
  {
    id: 'primera-visita',
    name: 'Primera Visita',
    discount: 15,
    description: '15% de descuento en tu primera cita',
    conditions: 'Solo para clientes nuevos. Válido una vez por persona.',
    code: 'BIENVENIDO15',
    active: true,
    newCustomersOnly: true
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.pexels.com/photos/35298999/pexels-photo-35298999.jpeg?w=600',
    category: 'Corte',
    title: 'Fade Moderno',
    specialist: 'Carlos Mendoza'
  },
  {
    id: 2,
    url: 'https://images.pexels.com/photos/5490240/pexels-photo-5490240.jpeg?w=600',
    category: 'Corte',
    title: 'Corte Texturizado',
    specialist: 'David Garza'
  },
  {
    id: 3,
    url: 'https://images.pexels.com/photos/4123900/pexels-photo-4123900.jpeg?w=600',
    category: 'Color',
    title: 'Highlights Naturales',
    specialist: 'Sofía Ramírez'
  },
  {
    id: 4,
    url: 'https://images.pexels.com/photos/13098976/pexels-photo-13098976.jpeg?w=600',
    category: 'Color',
    title: 'Balayage Premium',
    specialist: 'Lucía Fernández'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=600',
    category: 'Barba',
    title: 'Barba Perfilada',
    specialist: 'Miguel Torres'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1596728325488-58c87691e9af?w=600',
    category: 'Barba',
    title: 'Diseño Artístico',
    specialist: 'Carlos Mendoza'
  },
  {
    id: 7,
    url: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=600',
    category: 'Facial',
    title: 'Facial Rejuvenecedor',
    specialist: 'Andrea López'
  },
  {
    id: 8,
    url: 'https://images.unsplash.com/photo-1552693673-1bf958298935?w=600',
    category: 'Facial',
    title: 'Tratamiento Premium',
    specialist: 'Andrea López'
  },
  {
    id: 9,
    url: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=600',
    category: 'Corte',
    title: 'Clásico Elegante',
    specialist: 'Miguel Torres'
  },
  {
    id: 10,
    url: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=600',
    category: 'Corte',
    title: 'Low Fade',
    specialist: 'Carlos Mendoza'
  },
  {
    id: 11,
    url: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=600',
    category: 'Color',
    title: 'Tinte Cenizo',
    specialist: 'Sofía Ramírez'
  },
  {
    id: 12,
    url: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600',
    category: 'Color',
    title: 'Mechas Doradas',
    specialist: 'Lucía Fernández'
  }
];

export const beforeAfterImages = [
  {
    id: 1,
    before: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400',
    after: 'https://images.pexels.com/photos/35298999/pexels-photo-35298999.jpeg?w=400',
    service: 'Fade Premium',
    specialist: 'Carlos Mendoza'
  },
  {
    id: 2,
    before: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    after: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=400',
    service: 'Barba Completa',
    specialist: 'Miguel Torres'
  },
  {
    id: 3,
    before: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400',
    after: 'https://images.pexels.com/photos/4123900/pexels-photo-4123900.jpeg?w=400',
    service: 'Color + Corte',
    specialist: 'Lucía Fernández'
  },
  {
    id: 4,
    before: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400',
    after: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=400',
    service: 'Transformación Completa',
    specialist: 'Carlos Mendoza'
  },
  {
    id: 5,
    before: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?w=400',
    after: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400',
    service: 'Facial Rejuvenecedor',
    specialist: 'Andrea López'
  },
  {
    id: 6,
    before: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400',
    after: 'https://images.pexels.com/photos/13098976/pexels-photo-13098976.jpeg?w=400',
    service: 'Balayage',
    specialist: 'Sofía Ramírez'
  }
];

// Generate time slots
export const generateTimeSlots = (branchId, date) => {
  const slots = [];
  const baseHours = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
  
  baseHours.forEach(hour => {
    [0, 30].forEach(minute => {
      const random = Math.random();
      let status = 'available';
      let remaining = null;
      
      if (random < 0.15) {
        status = 'full';
      } else if (random < 0.35) {
        status = 'limited';
        remaining = Math.floor(Math.random() * 2) + 1;
      }
      
      // Peak hours logic
      const isPeakHour = (hour >= 11 && hour <= 13) || (hour >= 17 && hour <= 19);
      
      slots.push({
        time: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
        status,
        remaining,
        isPeakHour
      });
    });
  });
  
  return slots;
};

// Stats for trust signals
export const stats = {
  monthlyBookings: 2847,
  averageRating: 4.8,
  totalReviews: 1129,
  repeatCustomers: 78
};
